<template>
  <div>
    <div class="tw-my-4"><back-nav :to="$route.name === 'InstalmentPayment'? null : 'CoverSummaryReview'" /></div>

    <top-card v-if="!$route.name === 'InstalmentPayment'" current="BranchSelections" :cover="120" :amount="120000" :progress-hidden="true">Please select your preferred service branch</top-card>

    <v-card class="tw-mt-5 md:tw-mt-16 tw-py-1 md:tw-py-1">
      <v-form v-model="isValid">
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">

          <div>
            <div class="tw-w-full tw-mt-4 md:tw-mt-10 tw-px-2 md:tw-px-10">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg">You will receive a digital certificate on your email after payment. If you would like  physical certificate please select the branch you want to collect it from</h3>
              <v-radio-group class="my-2 tw-px-0 md:tw-px-6" v-model="selectBranch2" :rules="[v => !!v || 'Selection choice is required']" row>
                <v-radio label="Digital Certificate" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Pick up location" :value="2" class="tw-mt-0 md:tw-mt-5"></v-radio>
              </v-radio-group>
            </div>
          </div>

          <div v-if="selectBranch2 === 2">
            <div class="tw-w-full tw-mt-4 md:tw-mt-10">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 ">You can now choose your Pick up Location, Date and Time</h3>
              <hr class="tw-mt-3 tw-mb-5">
            </div>
            <v-row class="tw-px-2 md:tw-px-8 lg:tw-px-16">
              <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="computedDateFormatted"
                        label="Date"
                        persistent-hint
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="tw-px-4"
                        :rules="[required('Date')]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu = false"
                      :min="new Date().toISOString().substr(0, 10)"
                      :allowed-dates="allowedDates"
                      color="primary"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="time"
                        label="Time"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="tw-px-4"
                        :rules="[required('Time')]"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                      ampm-in-title
                      v-if="menu2"
                      v-model="time"
                      full-width
                      @click:minute="$refs.menu.save(time)"
                      :allowed-hours="allowedHours"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-radio-group v-model="branchCode1" v-if="!branchesLoading" :rules="[v => !!v || 'Pick up Location is required']">
              <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-px-2 md:tw-px-8">
                <v-radio v-for="(branch, $index) in branches" :key="$index" :value="branch.code" class="tw-px-2 md:tw-px-5 tw-mt-3 md:tw-mt-6">
                  <template #label>
                    <ul class="list-none">
                      <li>{{ branch.name }}</li>
                      <li class="tw-mt-1"><span class="c-blue-text">{{ branch.address }}</span></li>
                      <li>Open:{{ branch.openingTime }} Close:{{ branch.closingTime }}</li>
                      <li><span class="c-blue-text">{{ branch.tel }}</span></li>
                    </ul>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
            <div v-else class="tw-w-full tw-flex tw-justify-center">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
          </div>

          <div v-if="coverType.covertypeId === 101" class="tw-px-4 md:tw-px-12 tw-mt-0 md:tw-mt-4">
            <v-checkbox v-model="checked1" :rules="[check()]">
              <template #label>
                <terms-and-conditions pre="I have" post="of the policy & I agree to inspect my car within 14 days from the day of collection of insurance certificate. If I fail to do so, my comprehensive policy plan will be downgraded to third party policy plan" />
              </template>
            </v-checkbox>
          </div>
          <div class="tw-px-4 md:tw-px-12 tw-mt-0">
              <v-checkbox v-model="checked" :rules="[check()]">
                <template #label>
                  <terms-and-conditions pre="I have" post="of the policy & I agree to the same" />
                </template>
              </v-checkbox>
            </div>

          <v-card-actions class="col-sm-6 offset-sm-3 tw-mt-5 md:tw-mt-8 tw-pb-8">
            <v-btn block large
                   color="secondary"
                   class="my-3 "
                   :loading="loading"
                   :disabled="!isValid || renewal.batchId === null || branchesLoading"
                   @click="proceed">
              Proceed To Payment
            </v-btn>
          </v-card-actions>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import TopCard from '@/components/buy/TopCard';
import BackNav from '@/components/buy/BackNav';
import axios from 'axios';
import { changeFormat, formatDate2, reverseFormat } from '@/utils/time';
import validations from '@/utils/validations';
import TermsAndConditions from '@/components/TermsAndConditions';
import { FB_RENEW_SELECT_BRANCH } from '@/utils/const';

export default {
  name: 'BranchSelectionReview',
  props: ['renewal'],
  components: { TermsAndConditions, BackNav, TopCard },
  data() {
    return {
      loading: false,
      pageLoading: true,
      branchesLoading: true,
      branches: [],
      isValid: false,
      ...validations,
      branchCode1: '189',
      checked1: '',
      date: '',
      menu: false,
      time: null,
      menu2: false,
      selectBranch2: 0,
    };
  },
  watch: {
    selectBranch2(val) {
      if (val === 1) {
        this.branchCode1 = '189';
      }
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate2(this.date);
    },
    quote() {
      return this.$store.getters['renewal/fetchQoute'];
    },
    coverType() {
      return this.quote.covertypes.find((id) => id.selected === 'Y') || this.quote.covertypes.find((id) => id.covertypeId === 101);
    },
  },
  mounted() {
    this.getBranches3();
  },
  methods: {
    async proceed() {
      this.loading = true;
      const branch = this.branches.find((e) => e.code === parseInt(this.branchCode1, 10));
      const locationData = {
        policyNumber: this.$route.params.policyNo,
        branchAddress: branch.address,
        branchClosingTime: branch.closingTime,
        branchCode: branch.code,
        branchLatitude: branch.latitude,
        branchLongitude: branch.longitude,
        branchName: branch.name,
        branchOpeningTime: branch.openingTime,
        branchShortDescription: branch.shortDescription,
        branchTel: branch.tel,
        pickupDate: this.computedDateFormatted,
        pickupLocation: branch.name,
        pickupTime: this.time,
        quoteId: this.quote.quoteId,
      };
      await axios.post('/customer/quotation/policy/update/pickup-location', locationData)
        .then(() => {
          this.$toast.success('Pick Up Location successfully set');
          this.loading = false;
          this.$analytics.logEvent(FB_RENEW_SELECT_BRANCH, { product: 'Renewal Journey Select Branch' });
          this.$emit('to-selecting-payment', this.renewal.batchId);
        });
    },
    changeFormat,
    formatDate2,
    reverseFormat,
    getBranches3() {
      axios.get('/customer/gis/branches/retrieveAll')
        .then((response) => {
          this.branches = response.data.object;
          this.branchesLoading = false;
        });
    },
    allowedDates: (val) => ![0, 6].includes(new Date(val).getDay()),
    allowedHours: (val) => ![0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20, 21, 22, 23, 24].includes(val),
  },
};
</script>
